module.exports = __webpack_public_path__ + "img/newpic.d6e29ec7.png";